"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../../core/factory/factory.mjs";
import { Box } from "../../../core/Box/Box.mjs";
import Combobox_module_default from "../Combobox.module.mjs";
import { useComboboxContext } from "../Combobox.context.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Combobox/ComboboxHeader/ComboboxHeader.tsx
const ComboboxHeader = factory((props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ComboboxHeader", null, props);
	return /* @__PURE__ */ jsx(Box, {
		...useComboboxContext().getStyles("header", {
			className,
			classNames,
			style,
			styles
		}),
		...others,
		onMouseDown: (event) => {
			event.preventDefault();
		}
	});
});
ComboboxHeader.classes = Combobox_module_default;
ComboboxHeader.displayName = "@mantine/core/ComboboxHeader";
//#endregion
export { ComboboxHeader };

//# sourceMappingURL=ComboboxHeader.mjs.map